<template>
  <div class="vx-row">
    <div class="vx-col w-full">
      <vs-row class="pb-2">

        <vx-card>


          <vs-row vs-w="12">
            <vs-col vs-type="flex" vs-lg="2" vs-sm="12" vs-xs="12">
              <vs-button @click="goBack" color="danger" type="border" icon="keyboard_backspace">Back</vs-button>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="4" vs-sm="12" vs-xs="12">
              <span class="mr-5">Select:</span>

              <v-select style="width:100%" v-model="selected_default_view_for_client_user" label="name"
                :options="selected_default_view_options" name="selected_default_view_for_client_user" />
            </vs-col>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="1" vs-sm="12" vs-xs="12">

<vs-button @click="saveDefaultViewPopup" color="danger" type="border">Save View</vs-button>
</vs-col>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="4" vs-sm="12" vs-xs="12">
              <h3>{{ campaignDetails['campaign_name'] }}</h3>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="1" vs-sm="12" vs-xs="12">
              <vs-button @click="viewOpportunities" color="danger" type="border">Opportunities</vs-button>
            </vs-col>
        
          </vs-row>

        </vx-card>
      </vs-row>

      <vs-row vs-w="12">
        <vs-col vs-type="flex" vs-lg="6" vs-sm="12" vs-xs="12">
          <vx-card title="Accounts" class="mr-3">


            <div class="agrid-scroll">
              <DataGrid :context="'AccountDataSourceForClientView'" ref="AccountDataSourceForClientView" :columnDefs="accountColumnDefs" :rowData="accountRecords"
                :dataSource="accountDataSource" :rowSelection="'single'"
                @viewClientUserAccountRecords="viewClientUserAccountRecords"
                @showContactsWithAccountID="showContactsWithAccountID">

                <template v-slot:refresh-button>
                  <vs-icon @click="refreshAccountDataSourceForClientView" size="small" color="dark" icon="refresh">
                  </vs-icon>
                </template>

              </DataGrid>


            </div>
            <div class="p-5"></div>
            <h4 v-if="selected_account_id">Account Fields</h4>


            <ClientDataGrid
            ref="ClientViewAccountFieldRef"
            :columnDefs="accountSDQCAccountFields"
            :rowData="getSDAccountSelectedFieldRecords"
            :rowSelection="'single'"
            v-if="selected_account_id"
          >
          </ClientDataGrid>
            <!-- <DataGrid :context="'ClientViewAccountFieldRef'" @onSDQCAccountFilterModified="onSDQCAccountFilterModified" v-if="selected_account_id"
              ref="ClientViewAccountFieldRef" :columnDefs="accountSDQCAccountFields" :sideBar=hideSideBar
              :rowData="accountSDQCAccountFieldsRecords" :dataSource="getSDAccountSelectedDataSource">
            </DataGrid> -->

          </vx-card>
        </vs-col>
        <vs-col vs-type="flex" vs-lg="6" vs-sm="12" vs-xs="12">
          <vx-card title="Contacts" class="mr-3">
            <div class="agrid-scroll">

              <DataGrid :context="'ContactDataSourceForClientView'" ref="ContactDataSourceForClientView"
                @viewClientUserContactRecords="viewClientUserContactRecords" :columnDefs="contactColumnDefs"
                :rowData="contactRecords" :dataSource="contactDataSource"
                :rowSelection="'single'"
                @showContactsFieldsWithContactID="showContactsFieldsWithContactID">
                <template v-slot:refresh-button>
                  <vs-icon @click="refreshContactDataSourceForClientView" size="small" color="dark" icon="refresh">
                  </vs-icon>
                </template>

              </DataGrid>

            </div>


            <div class="p-5"></div>

            <h4 v-if="selected_contact_id">Comment</h4>
            <DataGrid :context="'ClientViewContactCommentFieldRef'" v-if="selected_contact_id" :sideBar=hideSideBar ref="ClientViewContactCommentFieldRef"
              :columnDefs="contactCommentFields" :rowData="contactCommentFieldsRecords"
              :dataSource="getSDContactSelectedCommentColumnDataSource" :pagination="pagination">
            </DataGrid>


            <div class="p-5"></div>

            <h4 v-if="selected_contact_id">Contact Fields</h4>
            <!-- <DataGrid :context="'ClientViewContactFieldRef'" :sideBar=hideSideBar @onSDQCAccountFilterModified="onSDQCAccountFilterModified"
              v-if="selected_contact_id" ref="ClientViewContactFieldRef" :columnDefs="contactSDQCContactFields"
              :rowData="contactSDQCContactFieldsRecords" :dataSource="getSDContactSelectedDataSource">
            </DataGrid> -->
            <ClientDataGrid
            ref="ClientViewContactFieldRef"
            :columnDefs="contactSDQCContactFields"
            :rowData="getSDContactSelectedFieldRecords"
            :rowSelection="'single'"
            v-if="selected_contact_id"
          >
          </ClientDataGrid>

          </vx-card>
        </vs-col>
      </vs-row>
      <vs-popup title="Save Default View" :active.sync="showHidesaveDefaultViewPopup">
        <vs-row>
          <vs-col vs-type="flex" vs-w="12">
            <div class="vx-row w-full">
              <div class="vx-col sm:w-1/4 w-full">
                <h6>Name:</h6>
              </div>
              <div class="vx-col sm:w-1/2 w-full">
                <vs-input class="w-full" v-model="save_view_name" name="name"  v-validate="'required'"/>
                <span class="text-danger text-sm mt-2 ml-16" v-show="errors.has('name')">{{
                  errors.first("name") }}</span>
              </div>
            </div>
          </vs-col>

          <vs-col vs-type="flex" vs-w="12">
            <div class="vx-row w-full mt-5">
              <div class="vx-col sm:w-1/4 w-full">
                <h6>Description:</h6>
              </div>
              <div class="vx-col sm:w-1/2 w-full">
                <vs-textarea class="w-full" name="save_view_description" v-model="save_view_description" />

                <vs-button class="mt-5" @click.prevent="submitClientUserDefaultViewAction">Submit</vs-button>
              </div>
            </div>
          </vs-col>

        </vs-row>
      </vs-popup>

      <vs-popup :title="'View Account'" fullscreen :active.sync="viewClientUserAccountPopup">
     

        <template v-for="(value,key, index) in editSelectedAccount">



          <template v-for="field_array_column in  editSelectedAccount['campaign_data_options']">



            <template v-if="field_array_column.column_id == key">


              <template  v-if="field_array_column.column_id == key && field_array_column.identifier != 'phone_type' && field_array_column.identifier != 'phone_code'">

          <div class="vx-row w-full mb-6">
              
            <div class="vx-col sm:w-1/3 w-full" >
              <span>{{ field_array_column.name }} :</span>



         
            </div>



            <div class="vx-col sm:w-1/3 w-full" v-if="field_array_column.identifier == 'website'">


              <template v-if="value == null || value == ''">

                {{ 'Empty' }}

              </template>

              <template v-else>

              

              <template v-for="d in JSON.parse(value)" v-if="JSON.parse(value).length !== 0">
                <div class="flex mb-4">
                  {{ d.url }}

                </div>
              </template>
              </template>

              
            </div>

            <div class="vx-col sm:w-1/3 w-full" v-else-if="field_array_column.identifier == 'linkedin'">

              <template v-if="value == null || value == ''">

                {{ 'Empty' }}

              </template>

              <template v-else>
              

              <template v-for="d in JSON.parse(value)" v-if="JSON.parse(value).length !== 0">
                <div class="flex mb-4">
                  {{ d.url }}

                </div>
              </template>
              </template>

              
            </div>

            <div class="vx-col sm:w-1/3 w-full" v-else-if="field_array_column.identifier == 'phone'">




              <template v-if="value == null || value == ''">

                {{ 'Empty' }}

              </template>

              <template v-else>
              

              <template v-for="d in JSON.parse(value)" v-if="JSON.parse(value).length !== 0">
                <div class="flex mb-4">
                  {{ d.phone_code }}    {{ d.phone_no }} {{ d.phone_type }}

                </div>
              </template>
              </template>

              
            </div>
            <div class="vx-col sm:w-1/3 w-full" v-else>

              

              <template v-if="field_array_column.type == 'textarea'">

                <template v-if="value == '' || value == null">
                  {{ 'Empty' }}
    
            </template>
    
            <template v-else>

              <div v-html="value"></div>

              
    
        </template>


              </template>

              <template v-else>


                <template v-if="value == '' || value == null">
                  {{ 'Empty' }}
    
            </template>
    
            <template v-else>
              
              {{ value }}
    
        </template>


              </template>
              


              
            </div>

          </div>

         




         



          </template>

        </template>
        </template>
        </template>

     

        
      </vs-popup>
  
      <vs-popup :title="'View Contact'" fullscreen :active.sync="viewClientViewContactPopUp">
     
        <template v-for="(value,key, index) in editSelectedContact">
      
      
      
          <template v-for="field_array_column in  editSelectedContact['campaign_data_options']">
      
      
            
      
              <template  v-if="field_array_column.column_id == key && field_array_column.identifier != 'ddi_phone_code' && field_array_column.identifier != 'mobile_phone_code'">
      
          <div class="vx-row w-full mb-6">
              
            <div class="vx-col sm:w-1/3 w-full" >
              <span>{{ field_array_column.name }} :</span>
      
      
      
         
            </div>
      
      
      
            <div class="vx-col sm:w-1/3 w-full" v-if="field_array_column.identifier == 'ddi'">


              <template v-if="value == null || value == ''">

                {{ 'Empty' }}

              </template>

              <template v-else>
                

              <template v-for="d in JSON.parse(value)" v-if="JSON.parse(value).length !== 0">
                <div class="flex mb-4">
                  {{ d.ddi_phone_code }} {{ d.ddi }} 
      
                </div>
              </template>


              <template v-else>
                
                {{ 'Empty' }}
      
          </template>
          </template>
      
              
            </div>

            <div class="vx-col sm:w-1/3 w-full" v-else-if="field_array_column.identifier == 'mobile'">

              <template v-if="value == null || value == ''">

                {{ 'Empty' }}

              </template>

              <template v-else>

              <template v-for="m in JSON.parse(value)" v-if="JSON.parse(value).length !== 0">
                <div class="flex mb-4">
                  {{ m.mobile_phone_code }} {{ m.mobile }}
      
                </div>
              </template>


              <template v-else>
                
                {{ 'Empty' }}
      
          </template>
          </template>
      
              
            </div>


            <div class="vx-col sm:w-1/3 w-full" v-else-if="field_array_column.identifier == 'email'">

              <template v-if="value == null || value == ''">

                {{ 'Empty' }}

              </template>

              <template v-else>
              <template v-for="e in JSON.parse(value)" v-if="JSON.parse(value).length !== 0">
                <div class="flex mb-4">
                  {{ e.email }}
      
                </div>
              </template>


              <template v-else>
                
                {{ 'Empty' }}
      
          </template>
          </template>
      
              
            </div>

            <div class="vx-col sm:w-1/3 w-full" v-else-if="field_array_column.identifier == 'contact_social_media'">


              <template v-for="s in JSON.parse(value)" v-if="JSON.parse(value).length !== 0">
                <div class="flex mb-4">
                  {{ s.social_media }} {{ s.summary }}
      
                </div>
              </template>


              <template v-else>
                
                {{ 'Empty' }}
      
          </template>
      
              
            </div>

        
      
       
             <div class="vx-col sm:w-1/3 w-full" v-else>


                <template v-if="field_array_column.type == 'textarea'">

                  <template v-if="value == '' || value == null">
                    {{ 'Empty' }}
      
              </template>
      
              <template v-else>

                <div v-html="value"></div>

                
      
          </template>


                </template>

                <template v-else>


                  <template v-if="value == '' || value == null">
                    {{ 'Empty' }}
      
              </template>
      
              <template v-else>
                
                {{ value }}
      
          </template>


                </template>


      
            
              
      
      
              
            </div> 
      
          </div>
      
         
      
      
      
      
         
      
      
      
          </template>
      
        </template>
        </template>
      
      </vs-popup>

    </div>
  </div>
</template>

<script>
var revanueValueFormatter = function (params) {
  return params.data.currency_name + " " + params.data.revenue;
  // return '$' + params.value
};
import moduleContactsManagement from "@/store/contacts-management/moduleContactsManagement.js";
import DataGrid from "@/components/aggrid/Aggrid.vue";
import defineAbilitiesFor from "@/config/abilities";
import moduleCampaignsManagement from "@/store/campaign-management/moduleCampaignManagement.js";
import vSelect from "vue-select";
import _ from "lodash";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import AccountAutocomplete from "@/components/autocomplete/AccountsAutocomplete.vue";
import moment from "moment";
import ClientDataGrid from "@/components/aggrid/AggridClient.vue";
import moduleAccountsManagement from "@/store/accounts-management/moduleAccountsManagement.js";
export default {
  data: () => ({
    getSDAccountSelectedFieldRecords: [],
    getSDContactSelectedFieldRecords: [],
    authorized:true,
    pagination: false,
    campaignDetails: [],
    hideSideBar: {
    },
    selectedCommentField: null,
    accountSDQCAccountFields: [
      {
        flex: 1,
        headerName: "Column",
        field: "column",
        filter: "agTextColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        }
      },
      {
        flex: 1,

        headerName: "Value",
        field: "value",
        filter: "agTextColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        },
        wrapText: true,
        autoHeight : true,
        cellRenderer : function(params) {
                            return params.value ? params.value : '';
                        },
        valueGetter: (params) => {
      return params.data.value;
    },
      }
    ],
    contactSDQCContactFields: [
      {
        flex: 1,
        headerName: "Column",
        field: "column",
        filter: "agTextColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        }
      },
      {
        flex: 1,

        headerName: "Value",
        field: "value",
        filter: "agTextColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        },
        wrapText: true,
        autoHeight : true,
        cellRenderer : function(params) {
                            return params.value ? params.value : '';
                        },
        valueGetter: (params) => {
      return params.data.value;
    },
      }
    ],
    contactCommentFields: [

      {
        flex: 1,
        headerName: "Value",
        field: "value",
        filter: "agTextColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        },
        wrapText: true,
        autoHeight : true,
        cellRenderer : function(params) {
                            return params.value ? params.value : '';
                        },
        valueGetter: (params) => {
      return params.data.value;
    },
      }
    ],
    accountSDQCAccountFieldsRecords: [],
    contactSDQCContactFieldsRecords: [],
    contactCommentFieldsRecords: [],
    viewClientUserAccountPopup: false,
    viewClientViewContactPopUp: false,
    phoneTypes: [],
    selected_sd_account_id: null,
    selected_contact_table_id: null,
    selected_account_table_id: null,
    selected_default_view_for_client_user: null,
    selected_default_view_options: [],
    showHidesaveDefaultViewPopup: false,
    please_choose_save_view_name: null,
    save_view_name: null,
    save_view_description: null,
    showAccountTagFilterOption: false,
    showContactTagFilterOption: false,
    selected_campaign: null,

    user_id: null,
    componentKey: 0,
    abilities: null,
    accountAccountDataSourceForClientViewFields: [
      {
        flex: 1,
        headerName: "Column",
        field: "column",
        filter: "agTextColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        }
      },
      {
        flex: 1,

        headerName: "Value",
        field: "value",
        filter: "agTextColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        }
      }
    ],
    contactContactDataSourceForClientViewFields: [
      {
        flex: 1,
        headerName: "Column",
        field: "column",
        filter: "agTextColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        }
      },
      {
        flex: 1,

        headerName: "Value",
        field: "value",
        filter: "agTextColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        }
      }
    ],
    accountColumnDefs: [],
    campaignFieldsDataSource: {},
    campaignFieldsRecords: [],
    campaignsRecords: [],
    selected_account_id: null,
    contactColumnDefs: [],
    campaignName: null,
    accountDataSource: {},
    campaignId: null,
    abilities: null,
    accountRecords: [],
    contactRecords: [],
    accountAccountDataSourceForClientViewFieldsRecords: [],
    contactContactDataSourceForClientViewFieldsRecords: [],
    selected_contact_id: null,
    contactDataSource: {},
    getSDAccountSelectedDataSource: {},
    getSDContactSelectedDataSource: {},
    contactParamsRequest: {},
    editSelectedAccount: {},
    editSelectedContact: {},
    selectedEditCampaignId: null,
    selectedEditAccountId: null,
    master_field_options: null,
    client_field_options: null,
    campaign_field_options: null,
    master_field_datas: {},
    client_field_datas: {},
    campaign_field_datas: {},
    contact_master_field_datas: {},
    contact_client_field_datas: {},
    contact_campaign_field_datas: {},
    core_field_datas: {},
    showHeadOfficeCountryField: true,
    showHeadOfficeEditAutocomplete: false,
    showRegisteredOfficeCountryField: true,
    showRegisteredOfficeEditAutocomplete: false,
    showRegistrationJurisdictionField: true,
    showRegistrationJurisdictionEditAutocomplete: false,
    showParentField: true,
    showParentEditAutocomplete: false,
    showVerticalField: true,
    showVerticalEditAutocomplete: false,
    showSatelliteOfficeCountryField: true,
    showSatelliteOfficeEditAutocomplete: false,
    roles: [],
    seniorities: [],
    sub_roles: [],
    primary_mobile: null,
    primary_ddi: null,
    dialAction: null,
    optionDescription: [],
    audittrial_action_type_id: null,
    audittrial_outcome_grade: null,
    audittrial_outcome_id: null,
    selected_options: [],
    showSchedulePopUp: false,
    selected_account_contact: null,
    old_master_field_datas: {},
  }),
  components: {
    "v-select": vSelect,
    DataGrid,
    AccountAutocomplete,
    ClientDataGrid

  },
  watch: {
    selected_default_view_for_client_user(val) {
      const account_saved_state = JSON.parse(val.account_view);
      this.$refs.AccountDataSourceForClientView.gridApi.applyColumnState({ state: account_saved_state, applyOrder: true });

      const contact_saved_state = JSON.parse(val.contact_view);
      this.$refs.ContactDataSourceForClientView.gridApi.applyColumnState({ state: contact_saved_state, applyOrder: true });

      const account_filter_saved_state = JSON.parse(val.account_filter);
      this.$refs.AccountDataSourceForClientView.gridApi.setFilterModel(account_filter_saved_state)

      const contact_filter_saved_state = JSON.parse(val.contact_filter);
      this.$refs.ContactDataSourceForClientView.gridApi.setFilterModel(contact_filter_saved_state)

    },
  },
  methods: {
    viewOpportunities() {
      this.$router.push({ path: "/client_opportunities/" + this.campaignId });
    },
    onSDQCAccountFilterModified(event) {
      // this.$refs.SDQCAccount.gridApi.refreshServerSide({purge : true});
      // this.getAccountDataSource();

      // this.$refs.SDQCContact.gridApi.refreshServerSide({purge : true});
      // this.getContactDataSource();


      this.$refs.ContactDataSourceForClientView.gridApi.refreshServerSide({purge : true});
      this.getContactDataSourceForClientView();
      this.getClientViewAccountSelectedFields();
    },
    // getClientViewAccountSelectedFields() {
    //   var self = this;
    //   this.getSDAccountSelectedDataSource = {
    //     getRows(params) {
    //       params.request.campaign_id = self.$route.params.campaignId;
    //       params.request.account_id = self.selected_account_id;
    //       self.$store
    //         .dispatch(
    //           "campaignsManagement/getSDAccountSelectedFields",
    //           params.request
    //         )
    //         .then(function (response) {
    //           let result = JSON.parse(response.data);

    //           result.forEach(function (ele,index) {
    //             let ele_column = Object.keys(ele);
    //             ele.column = ele_column;
    //             let ele_value = Object.values(ele)[0];
    //             if (
    //               ele_value != null &&
    //               ele_value != "[None]" &&
    //               ele_value != "None"
    //             ) {
    //               ele.value = ele_value;
    //               ele.index = index;
    //             }
    //             return ele;
    //           });

    //           result = result.filter(ele => ele.value != null && ele.value != '')
    //           if (result.length != 0) {
    //             self.$refs.ClientViewAccountFieldRef.gridApi.hideOverlay();
    //             return params.success({ rowData: result })
    //           } else {
    //             self.$refs.ClientViewAccountFieldRef.gridApi.showNoRowsOverlay();
    //             return params.success({ rowData: [] })
    //           }
    //         })
    //         .catch(err => {
    //           console.error(err);
    //         });
    //     }
    //   };
    // },
    getClientViewAccountSelectedFields() {
      var self = this;

      let data = {};
      data.campaign_id =  self.$route.params.campaignId
      data.account_id = self.selected_account_id
      self.$store
        .dispatch("accountsManagement/fetchAllClientViewAccountFieldsForClientSide", data)
        .then(function(response) {
          let result = JSON.parse(response.data)

              result.forEach(function (ele) {
                let ele_column = Object.keys(ele)
                ele.column = ele_column
                let ele_value = Object.values(ele)[0]
                if (
                  ele_value != null &&
                  ele_value != '[None]' &&
                  ele_value != 'None'
                ) {
                  ele.value = ele_value
                }
                return ele
              })

              result = result.filter(ele => ele.value != null && ele.value != '')


          self.getSDAccountSelectedFieldRecords = result;


        })
        .catch(err => {
          console.error(err);
        });


    },
    // getClientViewContactSelectedFields() {
    //   var self = this;
    //   this.getSDContactSelectedDataSource = {
    //     getRows(params) {
    //       params.request.campaign_id = self.$route.params.campaignId;
    //       params.request.contact_id = self.selected_contact_id;
    //       self.$store
    //         .dispatch(
    //           "campaignsManagement/getSDContactSelectedFields",
    //           params.request
    //         )
    //         .then(function (response) {
    //           let result = JSON.parse(response.data);

    //           result.forEach(function (ele,index) {
    //             let ele_column = Object.keys(ele);
    //             ele.column = ele_column;
    //             let ele_value = Object.values(ele)[0];
    //             if (
    //               ele_value != null &&
    //               ele_value != "[None]" &&
    //               ele_value != "None"
    //             ) {
    //               ele.value = ele_value;
    //               ele.index = index;
    //             }
    //             return ele;
    //           });

    //           result = result.filter(ele => ele.value != null && ele.value != '')
              

    //           if (result.length != 0) {
    //             self.$refs.ClientViewContactFieldRef.gridApi.hideOverlay();
    //             return params.success({ rowData: result })
    //           } else {
    //             self.$refs.ClientViewContactFieldRef.gridApi.showNoRowsOverlay();
    //             return params.success({ rowData: [] })
    //           }
    //         })
    //         .catch(err => {
    //           console.error(err);
    //         });
    //     }
    //   };
    // },
    getClientViewContactSelectedFields() {
      var self = this;

      let data = {};
      data.campaign_id =  self.$route.params.campaignId
      data.contact_id = self.selected_contact_id
      self.$store
        .dispatch("accountsManagement/fetchAllClientViewContactFieldsForClientSide", data)
        .then(function(response) {
          let result = JSON.parse(response.data)

              result.forEach(function (ele) {
                let ele_column = Object.keys(ele)
                ele.column = ele_column
                let ele_value = Object.values(ele)[0]
                if (
                  ele_value != null &&
                  ele_value != '[None]' &&
                  ele_value != 'None'
                ) {
                  ele.value = ele_value
                }
                return ele
              })

              result = result.filter(ele => ele.value != null && ele.value != '')


          self.getSDContactSelectedFieldRecords = result;


        })
        .catch(err => {
          console.error(err);
        });


    },
    getAlreadySelectedDefaultFields() {
      let self = this;
      let selected_campaign_id = self.$route.params.campaignId;
      self.$store
        .dispatch(
          "campaignsManagement/fetchAlreadySelectedDefaultFields",
          selected_campaign_id
        )
        .then(response => {
          let result = response.data
          if(response.data == null){
            self.$vs.dialog({
                type: "alert",
                color: "danger",
                title: `Client Accounts/Contacts `,
                text: `Client Default Fields is not selected. Please contact Admin `,
                acceptText: "OK"
              });

          }else{
            self.selectedCommentField = result['comment_field'];
          }

          
        })
        .catch(err => {
          if (err.response.status === 401) {
            self.$router.replace("/login");
          }
        });
    },
    getClientViewContactSelectedCommentFields() {
      var self = this;
      this.getSDContactSelectedCommentColumnDataSource = {
        getRows(params) {
          params.request.campaign_id = self.$route.params.campaignId;
          params.request.contact_id = self.selected_contact_id;
          self.$store
            .dispatch(
              "campaignsManagement/getSDContactSelectedFields",
              params.request
            )
            .then(function (response) {
              let result = JSON.parse(response.data);





               console.log("Comment fielsssssd" , result)



              result.forEach(function (ele,index) {
                let ele_column = Object.keys(ele);
                ele.column = ele_column;
                let ele_value = Object.values(ele)[0];
                if (
                  ele_value != null &&
                  ele_value != "[None]" &&
                  ele_value != "None"
                ) {
                  ele.value = ele_value;
                  ele.index = index;

                }
                return ele;
              });

              // result = result.filter(ele => ele.value != null && ele.value != '')

              // if (self.selectedCommentField != null) {
              //   self.selectedCommentField = JSON.parse(self.selectedCommentField);
              // }

              // result = result.filter(ele => ele['column'] == self.selectedCommentField.id);


              // console.log("Comment field" , result)

              if (result.length != 0) {
                self.$refs.ClientViewContactCommentFieldRef.gridApi.hideOverlay();
                return params.success({ rowData: result })
              } else {
                self.$refs.ClientViewContactCommentFieldRef.gridApi.showNoRowsOverlay();
                return params.success({ rowData: [] })
              }
            })
            .catch(err => {
              console.error(err);
            });
        }
      };
    },
    showContactsWithAccountID(account_id) {
      if (account_id == null) {
        this.$refs.AccountDataSourceForClientView.gridApi.clearFocusedCell();
      }

      this.selected_account_id = account_id;


      this.$refs.ContactDataSourceForClientView.gridApi.refreshServerSide({purge : true});
      this.getContactDataSourceForClientView();



      this.getClientViewAccountSelectedFields();

    },
    showContactsFieldsWithContactID(contact_id,account_id) {
      if (contact_id == null) {
        this.$refs.AccountDataSourceForClientView.gridApi.clearFocusedCell();
      }
      this.selected_contact_id = contact_id;

      this.$refs.AccountDataSourceForClientView.gridApi.refreshServerSide({purge : true});
      this.getAccountDataSourceForClientView();

      this.getClientViewContactSelectedFields();


      this.$refs.ClientViewContactCommentFieldRef.gridApi.refreshServerSide({purge : true});
      this.getClientViewContactSelectedCommentFields();

      // alert("show notes")
    },
    viewClientUserAccountRecords(account) {


      let self = this;

     
      self.viewClientUserContactPopup = false;
      self.viewClientUserAccountPopup = true;
      // this.editSelectedAccount = account
      let data = {};
      data.account_id = account.acc_id;
      data.campaign_id = account.account_campaign_id;
      self.selectedEditCampaignId = account.account_campaign_id;
      self.selectedEditAccountId = account.acc_id;
      self.selected_account_status = account.account_status;
      self.selected_account_table_id = account.table_id;

      self.$store
        .dispatch("accountsManagement/getClientViewAccountFromClientTable", data)
        .then(res => {
          if (res.data) {
            self.editSelectedAccount = JSON.parse(res.data);


          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    viewClientUserContactRecords(contact) {
      let self = this;

     

      self.viewClientUserAccountPopup = false;

      self.viewClientViewContactPopUp = true;
      // this.editSelectedAccount = account
      let data = {};
      data.contact_id = contact.contact_id;
      data.campaign_id = contact.campaign_id;
      self.selectedEditCampaignId = contact.campaign_id;
      self.selectedEditContactId = contact.contact_id;

      self.selected_sd_account_id = contact.account_id;
      self.selected_account_id = contact.account_id;

      self.selected_contact_status = contact.contact_status;
      self.selected_contact_table_id = contact.table_id;

      self.$store
        .dispatch("accountsManagement/getClientViewContact", data)
        .then(res => {
          if (res.data) {
            self.editSelectedContact = JSON.parse(res.data);


          
          }
        })
        .catch(err => {

          console.log(err);
        });

      // var array = ["id","acc_id","campaign_id","contact_campaign_id","contact_id","contact_status","contact_id", "contact_status","contact_web"];
      // this.editSelectedContact = this.deleteKeys(contact, array);
      // console.log("Contact", this.editSelectedContact);
    },
    refreshAccountDataSourceForClientView() {
      this.$refs.AccountDataSourceForClientView.gridApi.setFilterModel(null);
      this.$refs.AccountDataSourceForClientView.gridApi.onFilterChanged();
    },
    refreshContactDataSourceForClientView() {
      this.$refs.ContactDataSourceForClientView.gridApi.setFilterModel(null);
      this.$refs.ContactDataSourceForClientView.gridApi.onFilterChanged();
    },
    getClientUserViews() {
      let self = this
      let data = {}
      data.campaign_id = self.campaignId;
      data.user_id = self.user_id;
      self.$store
        .dispatch("campaignsManagement/getClientUserViews", data)
        .then(res => {
          if (res) {
            let response_data = res.data
            if (response_data){
              response_data = JSON.parse(res.data)
              self.selected_default_view_options = response_data

            }
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    submitClientUserDefaultViewAction() {
      let self = this



      this.$validator.validateAll().then(result => {
        if (result) {


          let data = {}
      data.name = self.save_view_name;
      data.description = self.save_view_description;
      data.campaign_id = self.campaignId;
      data.account_view = self.$refs.AccountDataSourceForClientView.gridApi.getColumnState()
      data.contact_view = self.$refs.ContactDataSourceForClientView.gridApi.getColumnState()
      data.account_filter = self.$refs.AccountDataSourceForClientView.gridApi.getFilterModel();
      data.contact_filter = self.$refs.ContactDataSourceForClientView.gridApi.getFilterModel();
      let save_view_user_id = []
      save_view_user_id.push(self.user_id)
      data.save_view_user_id = save_view_user_id
      data.is_default_view = false
      if (self.save_view_name != null) {
        self.$store
          .dispatch("campaignsManagement/submitClientUserDefaultViewAction", data)
          .then(res => {
            if (res) {
              if (res.data.status == "success") {

                location.reload()
                // self.getClientUserViews()
                // self.$refs.AccountDataSourceForClientView.gridApi.refreshServerSide({purge : true});
                // self.getAccountDataSourceForClientView();
                // self.$refs.ContactDataSourceForClientView.gridApi.refreshServerSide({purge : true});
                // self.getContactDataSourceForClientView();
                // self.showHidesaveDefaultViewPopup = false;
              }
              else{

self.$vs.notify({
color: "danger",
title: "Default View",
text: res.data.message
});
}
            }
          })
          .catch(err => {
            console.log(err);
          });
      }

        }
      })
     


    },
    saveDefaultViewPopup() {
      this.showHidesaveDefaultViewPopup = true
    },

    getAccountDataSourceForClientView() {
      var self = this;
      this.accountDataSource = {
        getRows(params) {


          if (!_.isEmpty(params.request.filterModel)) {
            self.contactParamsRequest = {};
          }

          if (!_.isEmpty(self.contactParamsRequest)) {
            params.request.filterModel = Object.assign(
              self.contactParamsRequest.filterModel,
              params.request.filterModel
            );
          }



          if (self.selected_contact_id != null) {
            params.request.selected_contact_id = self.selected_contact_id;
          }

          params.request.campaignId = self.$route.params.campaignId;
          params.request.userId = self.user_id;
          // params.request.campaignName = 'Fishy Campaign';

          self.$store
            .dispatch("accountsManagement/fetchAllAccountDataSourceForClientView", params.request)
            .then(function (response) {
              let response_data = response.rows;
              response_data.forEach(function (ele) {



                if (ele._c2c0a5f8_e0aa_4ea9_b0e9_92195a9245a0) {
                  ele._c2c0a5f8_e0aa_4ea9_b0e9_92195a9245a0 = JSON.parse(ele._c2c0a5f8_e0aa_4ea9_b0e9_92195a9245a0)
                  if (ele._c2c0a5f8_e0aa_4ea9_b0e9_92195a9245a0.length == 0) {
                    ele._c2c0a5f8_e0aa_4ea9_b0e9_92195a9245a0 = "";
                  } else if (ele._c2c0a5f8_e0aa_4ea9_b0e9_92195a9245a0.length > 1) {
                    ele._c2c0a5f8_e0aa_4ea9_b0e9_92195a9245a0 = "ΞΞ";
                  } else {
                    ele._c2c0a5f8_e0aa_4ea9_b0e9_92195a9245a0 = ele._c2c0a5f8_e0aa_4ea9_b0e9_92195a9245a0[0].url;
                  }
                }

                if (ele._c68046a9_7aaf_4876_9c49_936c28d479af) {
                  ele._c68046a9_7aaf_4876_9c49_936c28d479af = JSON.parse(ele._c68046a9_7aaf_4876_9c49_936c28d479af)

                  if (ele._c68046a9_7aaf_4876_9c49_936c28d479af.length == 0) {
                    ele._c68046a9_7aaf_4876_9c49_936c28d479af = "";
                  } else if (ele._c68046a9_7aaf_4876_9c49_936c28d479af.length > 1) {
                    ele._c68046a9_7aaf_4876_9c49_936c28d479af = "ΞΞ";
                  } else {
                    ele._c68046a9_7aaf_4876_9c49_936c28d479af = ele._c68046a9_7aaf_4876_9c49_936c28d479af[0].url;
                  }
                }

                if (ele._a8bbf05f_56fe_408a_aff0_0f50ce33bf1a) {
                  ele._a8bbf05f_56fe_408a_aff0_0f50ce33bf1a = JSON.parse(ele._a8bbf05f_56fe_408a_aff0_0f50ce33bf1a)

                  if (ele._a8bbf05f_56fe_408a_aff0_0f50ce33bf1a.length == 0) {
                    ele._a8bbf05f_56fe_408a_aff0_0f50ce33bf1a = "";
                  } else if (ele._a8bbf05f_56fe_408a_aff0_0f50ce33bf1a.length > 1) {
                    ele._a8bbf05f_56fe_408a_aff0_0f50ce33bf1a = "ΞΞ";
                  } else {
                    ele._a8bbf05f_56fe_408a_aff0_0f50ce33bf1a = ele._a8bbf05f_56fe_408a_aff0_0f50ce33bf1a[0].phone_code + ele._a8bbf05f_56fe_408a_aff0_0f50ce33bf1a[0].phone_no;
                  }
                }


                if (ele.switchboard) {
                  ele.switchboard = ele.switchboard_phone_code + ele.switchboard;
                }


              });

              if (response_data.length != 0) {
                self.$refs.AccountDataSourceForClientView.gridApi.hideOverlay();
                params.success({ rowData: response.rows , rowCount: response.lastRow })
              } else {
                self.$refs.AccountDataSourceForClientView.gridApi.showNoRowsOverlay();
                return params.success({ rowData: [] })
              }
            })
            .catch(err => {
              console.error(err);
            });
        }
      };
    },
    getContactDataSourceForClientView() {
      var self = this;
      this.contactDataSource = {
        getRows(params) {

          self.contactParamsRequest = params.request;
          params.request.campaignId = self.$route.params.campaignId;
          params.request.userId = self.user_id;
          // params.request.campaignName = 'Fishy Campaign';
          params.request.selected_account_id = self.selected_account_id;

          self.$store
            .dispatch("accountsManagement/fetchAllContactDataSourceForClientView", params.request)
            .then(function (response) {
              let response_data = response.rows;

              response_data.forEach(function (ele) {




                if(ele._0c483105_8807_4d68_8299_91f449e7085a){

                  ele._0c483105_8807_4d68_8299_91f449e7085a = JSON.parse(ele._0c483105_8807_4d68_8299_91f449e7085a)
                  if (ele._0c483105_8807_4d68_8299_91f449e7085a.length == 0) {
                  ele._0c483105_8807_4d68_8299_91f449e7085a = "";
                } else if (ele._0c483105_8807_4d68_8299_91f449e7085a.length > 1) {
                  ele._0c483105_8807_4d68_8299_91f449e7085a = "ΞΞ";
                } else {
                  ele._0c483105_8807_4d68_8299_91f449e7085a = ele._0c483105_8807_4d68_8299_91f449e7085a[0].ddi_phone_code + ele._0c483105_8807_4d68_8299_91f449e7085a[0].ddi;
                }

                }
               

                if(ele._f045b88c_3b21_4a30_9576_f566641e3447){
                  ele._f045b88c_3b21_4a30_9576_f566641e3447 = JSON.parse(ele._f045b88c_3b21_4a30_9576_f566641e3447)

                if (ele._f045b88c_3b21_4a30_9576_f566641e3447.length == 0) {
                  ele._f045b88c_3b21_4a30_9576_f566641e3447 = "";
                } else if (ele._f045b88c_3b21_4a30_9576_f566641e3447.length > 1) {
                  ele._f045b88c_3b21_4a30_9576_f566641e3447 = "ΞΞ";
                } else {
                  ele._f045b88c_3b21_4a30_9576_f566641e3447 = ele._f045b88c_3b21_4a30_9576_f566641e3447[0].mobile_phone_code + ele._f045b88c_3b21_4a30_9576_f566641e3447[0].mobile;
                }
              }

                if(ele._2619e88b_cc7c_48bd_8934_de7113d6b849){
                  ele._2619e88b_cc7c_48bd_8934_de7113d6b849 = JSON.parse(ele._2619e88b_cc7c_48bd_8934_de7113d6b849)

                  ele.all_social_media = ele._2619e88b_cc7c_48bd_8934_de7113d6b849




                  if (ele._2619e88b_cc7c_48bd_8934_de7113d6b849.length == 0) {
                  ele._2619e88b_cc7c_48bd_8934_de7113d6b849 = "";
                } else if (ele._2619e88b_cc7c_48bd_8934_de7113d6b849.length > 1) {
                  ele._2619e88b_cc7c_48bd_8934_de7113d6b849 = "ΞΞ";
                } else {

                  ele._2619e88b_cc7c_48bd_8934_de7113d6b849 = ele._2619e88b_cc7c_48bd_8934_de7113d6b849[0]['social_media']
                  ele._053ef7ea_b2ed_4110_8318_76d7e8268526 = ele.all_social_media[0]['summary']
                }

                }
               

                if(ele._7f678dc8_5d41_4ca3_aaad_deedfb594a6d){
                  ele._7f678dc8_5d41_4ca3_aaad_deedfb594a6d = JSON.parse(ele._7f678dc8_5d41_4ca3_aaad_deedfb594a6d)

                  if (ele._7f678dc8_5d41_4ca3_aaad_deedfb594a6d.length == 0) {
                    ele._7f678dc8_5d41_4ca3_aaad_deedfb594a6d = "";
                  } else if (ele._7f678dc8_5d41_4ca3_aaad_deedfb594a6d.length > 1) {
                    ele._7f678dc8_5d41_4ca3_aaad_deedfb594a6d = "ΞΞ";
                  } else {
                    ele._7f678dc8_5d41_4ca3_aaad_deedfb594a6d = ele._7f678dc8_5d41_4ca3_aaad_deedfb594a6d[0].email;
                  }
              }
              });

              if (response_data.length != 0) {
                self.$refs.ContactDataSourceForClientView.gridApi.hideOverlay();
                params.success({ rowData: response.rows , rowCount: response.lastRow })
              } else {
                self.$refs.ContactDataSourceForClientView.gridApi.showNoRowsOverlay();
                return params.success({ rowData: [] })
              }
            })
            .catch(err => {
              console.error(err);
            });
        }
      };
    },
    getAccountColumnsForDefaultClientView () {
      let self = this
      self.$store
        .dispatch(
          'campaignsManagement/getColumnsForDefaultClientView',
          self.$route.params.campaignId
        )
        .then(res => {
          let result = res.data
          if (result) {
            let account_columns = result['account_fields']


            account_columns = account_columns.filter(function(ele) {
    return ele.identifier != 'phone_code' && ele.identifier != 'phone_type'
  });



          



            account_columns.forEach(function (ele) {
              ele.headerName = ele.name
              ele.field = ele.column_id


              if (ele.type == "textarea") {
                ele.cellRenderer =  function(params) {
                            return params.value ? params.value : '';
                        }
              }
                if (ele.type == "date" || ele.type == "datetime") {
                  ele.filter = "agDateColumnFilter";
                } else if (ele.type == "number") {
                  ele.filter = "agNumberColumnFilter";
                } else {
                  ele.filter = "agTextColumnFilter";
                }



              ele.flex = 1
              ele.filterParams = {
                buttons: ['apply', 'reset'],
                maxNumConditions: 4
              }
            })

        

            let actions = {
              headerName: 'Actions',
              sortable: false,
              field: 'transactions',
              cellRenderer: 'CellRendererActions',
              suppressHeaderMenuButton: true,
              pinned: true,
              width: 110
            }

            this.accountColumnDefs = account_columns
            this.accountColumnDefs.push(actions)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    getContactColumnsForDefaultClientView () {
      let self = this
      self.$store
        .dispatch(
          'campaignsManagement/getColumnsForDefaultClientView',
          self.$route.params.campaignId
        )
        .then(res => {
    let result = res.data
    if (result) {
      let contact_columns = result['contact_fields']

      


      contact_columns = contact_columns.filter(function(ele) {
              return ele.identifier != 'mobile_phone_code' && ele.identifier != 'ddi_phone_code'
            });



      contact_columns.forEach(function (ele) {
        ele.headerName = ele.name
        ele.field = ele.column_id


        if (ele.type == "textarea") {
                ele.cellRenderer =  function(params) {
                            return params.value ? params.value : '';
                        }
              }
                if (ele.type == "date" || ele.type == "datetime") {
            ele.filter = "agDateColumnFilter";
          } else if (ele.type == "number") {
            ele.filter = "agNumberColumnFilter";
          } else {
            ele.filter = "agTextColumnFilter";
          }



        ele.flex = 1
        ele.filterParams = {
          buttons: ['apply', 'reset'],
          maxNumConditions: 4
        }
      })


      this.contactColumnDefs = contact_columns

      // let grade = {
      //   headerName: 'Grade',
      //   field: 'grade',
      //   filter : "agNumberColumnFilter",
      //   filterParams: {
      //     buttons: ['apply', 'reset'],
      //     maxNumConditions: 4
      //   },
      //   flex: 1

      // }

      // this.contactColumnDefs.push(grade)
  

      let actions = {
        headerName: 'Actions',
        sortable: false,
        field: 'transactions',
        cellRenderer: 'CellRendererActions',
        suppressHeaderMenuButton: true,
        pinned: true,
        width: 110
      }

      this.contactColumnDefs.push(actions)


      console.log("Contact Column Defs", this.contactColumnDefs)
    }
  })
        .catch(err => {
          console.log(err)
        })
    },
    fetchCampaignDetails() {
      const campaignId = this.$route.params.campaignId;
      this.$store
        .dispatch("campaignsManagement/fetchCampaign", campaignId)
        .then(res => {
          this.campaignDetails = res.data;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    checkClientUserCampaignPermission() {
      let data = {}
      data.campaign_id = this.$route.params.campaignId;
      data.user_id = this.user_id;
      this.$store
        .dispatch("campaignsManagement/checkClientUserCampaignPermission" , data)
        .then(res => {
          let result = JSON.parse(res.data)
          if (result.length == 0){
            this.authorized = false
            this.$router.replace("/unauthorized")
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    goBack: function () {
      this.$router.go(-1);
    },
    getRoles() {
      this.$store
        .dispatch("contactsManagement/getRoles")
        .then(res => {
          this.roles = res.data;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },

  },
  beforeMount() {
    if(this.authorized){
      this.getAccountColumnsForDefaultClientView();
    this.getContactColumnsForDefaultClientView();
    this.getAccountDataSourceForClientView();
    this.getContactDataSourceForClientView();
    this.getClientViewContactSelectedCommentFields()

    }


  },
  mounted() {
    var self = this;

    if(this.authorized){
      self.getClientUserViews()
    self.getAlreadySelectedDefaultFields()
    self.fetchCampaignDetails()
    }
 

  },
  created() {
    var self = this;
    defineAbilitiesFor().then(function (data) {
      self.abilities = data;
    });

    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.user_id = userInfo["uid"];
    this.user_role = userInfo["userRole"];

    // if (this.user_role != 'Client Administrator' && this.user_role != 'Client'){
    //   this.authorized = false
    //   this.$router.replace("/unauthorized")
    // }

    if (this.user_role == 'Sales Developer'){
      this.authorized = false
      this.$router.replace("/unauthorized")
    }


    if (!moduleCampaignsManagement.isRegistered) {
      this.$store.registerModule(
        "campaignsManagement",
        moduleCampaignsManagement
      );
      moduleCampaignsManagement.isRegistered = true;
    }

    if (!moduleAccountsManagement.isRegistered) {
      this.$store.registerModule(
        "accountsManagement",
        moduleAccountsManagement
      );
      moduleAccountsManagement.isRegistered = true;
    }



    if (!moduleContactsManagement.isRegistered) {
      this.$store.registerModule(
        "contactsManagement",
        moduleContactsManagement
      );
      moduleContactsManagement.isRegistered = true;
    }

    this.campaignId = self.$route.params.campaignId;

    this.checkClientUserCampaignPermission()
  }
};
</script>
<style scoped>
.audit_trial_style {
  height: 600px;
  overflow-y: scroll;
}

.removeButton {
  cursor: pointer;
}

.vs-table--tbody-table tr {
  -webkit-transition: none;
  transition: none;
  background: #fff;
}

.searchbox {
  margin-left: 5px;
  width: 600px;
}

.filter {
  width: 300px;
}

.pointer {
  cursor: pointer;
}

.item.expanded {
  background-color: white !important;
  color: black !important;
}

.pointer {
  cursor: pointer;
}

.address_th {
  padding: 30px;
}

.address_td {
  padding: 30px;
  font-weight: 500;
}

.agrid-scroll {
  overflow-x: hidden;
  overflow-y: scroll;
  height: 572px;
  padding-right: 15px;
}

.td .vs-table--td {
  width: 100%;
}

.ql-class {
  width: 580px;

}

.vertical-align {
  font-size: 10px;
  display: flex;
  justify-content: center;
  /* align horizontal */
  align-items: center;
  /* align vertical */
  /* width: 800px; */
}
</style>
